import * as config from "config-api";
import { fetch } from "../../index";
import {
    videoContentItemsByCategorySlugs,
    videoContentItemsBySourceIds,
} from "../../fragments/media";
import { allContentItemsWithFragment } from "../../queries/allContentItems";
import { HttpError } from "../../../../utils/errors/http";
import { HTTP_BAD_REQUEST } from "../../../../constants/http";
import { isSourceId } from "../../../../utils/dataTransform/ContentItem/library";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const getVideoContentItemsBySourceIds = (sourceIds, pageSize = 10) => {
    const badSourceIdsError = new HttpError(
        HTTP_BAD_REQUEST,
        "Bad list of  sourceIds supplied"
    );
    if (!Array.isArray(sourceIds) || !sourceIds.length) {
        return Promise.reject(badSourceIdsError);
    }

    const ids = sourceIds.filter((id) => isSourceId(id)).join(",");
    if (ids === "") {
        return Promise.reject(badSourceIdsError);
    }

    const graphqlQuery = videoContentItemsBySourceIds();

    const graphqlVariables = {
        sourceIds: ids,
        pageSize,
    };

    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: graphqlQuery,
            variables: { ...graphqlVariables },
        },
        false
    );
};

export const getPolopolyVideoByLineupSlug = (
    lineupSlug,
    pageSize,
    mediaAspectRatios
) => {
    const graphqlQuery = allContentItemsWithFragment();
    const graphqlVariables = {
        lineupSlug,
        type: "video",
        pageSize,
    };

    if (mediaAspectRatios) {
        graphqlVariables.mediaAspectRatios = mediaAspectRatios;
    }

    return fetch(GRAPHQL_BASE_URL, {
        query: graphqlQuery,
        variables: {
            ...graphqlVariables,
        },
    });
};

export const getVideoItemsByCategorySlugs = (
    categorySlugs,
    numMaxItems,
    streamType,
    mediaAspectRatios
) => {
    if (!categorySlugs) {
        return Promise.reject(
            new HttpError(HTTP_BAD_REQUEST, "Bad categorySlugs supplied")
        );
    }

    const graphqlQuery = videoContentItemsByCategorySlugs();
    const graphqlVariables = {
        lineupOnly: false,
        itemsQueryFilters: {
            categorySlugs: categorySlugs,
            numMaxItems: numMaxItems,
            sort: "-publishedAt",
            types: ["video"],
        },
    };

    if (mediaAspectRatios) {
        graphqlVariables.mediaAspectRatios = mediaAspectRatios;
    }

    if (streamType) {
        graphqlVariables.itemsQueryFilters.mediaStreamType = streamType;
    }

    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: graphqlQuery,
            variables: { ...graphqlVariables },
        },
        false
    );
};
